import type { Citation, Document } from '@/features/documents/types';

const DRAWING_DOCUMENT_CATEGORIES = new Set(['TECHNICAL_DRAWINGS', 'LAYOUT']);

export const citationDocumentId = (citation: Pick<Citation, 'url' | 'filepath'>) =>
  citation.url.length > 0 ? citation.url : citation.filepath;

export const isDrawingCitation = (
  citation: Pick<Citation, 'documentCategory'>,
  document?: Pick<Document, 'documentCategory' | 'extension'> | null,
) => {
  if (document && document.extension?.toUpperCase() !== 'PDF') return false;
  const category = citation.documentCategory ?? document?.documentCategory;
  return !!category && DRAWING_DOCUMENT_CATEGORIES.has(category);
};

const drawingSheetShortTitle = (title: string) => {
  const trimmed = title.trim();
  if (!trimmed) return '';
  return trimmed.split(/\s+[—–-]\s+/)[0] ?? trimmed;
};

export const citationPage = (pageStart?: number) =>
  pageStart !== undefined && pageStart > 0 ? pageStart : undefined;

export const drawingCitationLabel = (
  citation: Pick<Citation, 'title' | 'filepath' | 'pageStart'>,
  page?: string,
) => {
  const name = drawingSheetShortTitle(citation.title) || citation.filepath.trim() || citation.title;
  return page ? `${name} (${page})` : name;
};
